export default __webpack_public_path__ + "static/media/Phil.cace1892.png";